import { darkGrayFontColor, label } from '../../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	automationCardSubTitle: {
		margin: '0 0 16px 0',
	},
	footer: {
		display: 'flex',
		justifyContent: 'center',
		margin: '32px 0 0 0',
	},
	main: {
		boxSizing: 'border-box',
		maxWidth: 460,
		padding: '0 30px',
	},
	sendToHoseholdCheckbox: {
		boxSizing: 'border-box',
		margin: '0 0 5px',
	},
	sendToHouseholdMessage: {
		color: darkGrayFontColor,
		fontSize: 14,
		margin: '0 0 30px 28px',
	},
	checkboxText: {
		color: label,
		fontSize: 14,
		marginBottom: 2,
		marginLeft: 16,
		marginTop: 0,
		width: 500,
	},
});
